import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SwPartNumberService } from '../../../services/sw-part-number.service';
import { TranslationService } from '../../../services/translation.service';
import { CommonUtils } from '../../../common/common-utils';

@Component({
  selector: 'app-current-language-and-sw-part-number-view',
  imports: [],
  templateUrl: './current-language-and-sw-part-number-view.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './current-language-and-sw-part-number-view.scss',
})
export class CurrentLanguageAndSwPartNumberView {
  private readonly swPartNumberService = inject(SwPartNumberService);
  private readonly languageService = inject(TranslationService);

  protected get currentLanguage(): string {
    return this.languageService.getLanguage() ?? 'N/A';
  }

  protected get currentSwPartNumber(): string {
    const result = this.swPartNumberService.getSwPartNumber()?.number ?? 'N/A';
    return CommonUtils.maskSwPartNumberMinorRelease(result)!;
  }
}
